import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';

const BASE_NAV_ITEMS = [
  { to: '/admin/dashboard', icon: '\uD83D\uDCCA', label: 'Dashboard' },
  { to: '/admin/users', icon: '\uD83D\uDC65', label: 'Users' },
  { to: '/admin/uniform-categories', icon: '\uD83D\uDCD1', label: 'Uniform Categories' },
  { to: '/admin/uniforms', icon: '\uD83D\uDC54', label: 'Uniforms' },
  { to: '/admin/uniform-reports', icon: '\uD83D\uDCCB', label: 'Uniform Reports' },
  { to: '/admin/missing-reports', icon: '\u26A0', label: 'Missing Reports' },
];

const SUPERADMIN_NAV_ITEMS = [
  { to: '/admin/companies', icon: '\uD83C\uDFE2', label: 'Companies' },
];

const AdminSidebar = ({ isOpen, isMinimized, onClose, onToggleMinimize }) => {
  const { logout, user } = useAuth();
  const navigate = useNavigate();

  const isSuperadmin = user?.role === 'superadmin';
  const navItems = isSuperadmin ? [...SUPERADMIN_NAV_ITEMS, ...BASE_NAV_ITEMS] : BASE_NAV_ITEMS;

  const handleLogout = async () => {
    await logout();
    navigate('/login', { replace: true });
  };

  return (
    <aside className={`admin-sidebar${isOpen ? ' admin-sidebar--open' : ''}${isMinimized ? ' admin-sidebar--minimized' : ''}`}>
      <div className="admin-sidebar__brand">
        <span className="admin-sidebar__logo">{'\uD83D\uDC55'}</span>
        <span className="admin-sidebar__title">TEMA Admin</span>
        <button
          type="button"
          className="admin-sidebar__collapse"
          onClick={onToggleMinimize}
          aria-label={isMinimized ? 'Expand sidebar' : 'Minimize sidebar'}
          title={isMinimized ? 'Expand sidebar' : 'Minimize sidebar'}
        >
          {isMinimized ? '>' : '<'}
        </button>
        <button
          type="button"
          className="admin-sidebar__close"
          onClick={onClose}
          aria-label="Tutup menu"
        >
          x
        </button>
      </div>

      <nav className="admin-sidebar__nav">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            onClick={onClose}
            title={isMinimized ? item.label : undefined}
            className={({ isActive }) =>
              `admin-sidebar__item${isActive ? ' admin-sidebar__item--active' : ''}`
            }
          >
            <span className="admin-sidebar__icon">{item.icon}</span>
            <span className="admin-sidebar__item-label">{item.label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="admin-sidebar__footer">
        <div className="admin-sidebar__user-name">{user?.name}</div>
        <div className="admin-sidebar__user-role">{user?.role}</div>
        <button className="admin-sidebar__logout" onClick={handleLogout}>
          <span className="admin-sidebar__logout-icon">{'\uD83D\uDEAA'}</span>
          <span className="admin-sidebar__logout-label">Logout</span>
        </button>
      </div>
    </aside>
  );
};

export default AdminSidebar;
